

import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function usuariocursoComboReducer(state= initialState.usuariocursoCombo, action){
	switch(action.type){
		case types.GET_USUARIOCURSOS_COMBO_SUCCESS:		            
			return action.datos;		
	
		default:
			return state;
	}
}